const ruJSON = {
  DUPLICATE_OF: 'Дубликат',
  DUPLICATED_BY: 'Продублирован',
  RELATED_TO: 'Связан с',
  SPLIT_TO: 'Разделён на',
  SPLIT_FROM: 'Разделён из',
  BLOCKED_BY: 'Заблокирован',
  BLOCKS: 'Блокирует',
  MORE_THAN: 'Больше чем',
  LESS_THAN: 'Меньше чем',
  OPEN: 'Открыт',
  IN_PROGRESS: 'В работе',
  ON_HOLD: 'Приостановлен',
  COMPLETE: 'Завершён',

  'home.built': 'Создано, чтобы упростить управление обслуживанием',
  home_description:
    'Когда доски и стикеры превращаются в хаос, а вам нужна CMMS-система, которую команда реально сможет использовать — попробуйте {{shortBrandName}}',
  try_grash: 'Попробовать {{shortBrandName}}',
  login: 'Войти',
  start_trial: 'Начать бесплатный пробный период',

  'home.what': 'Что',
  'home.you_will_have': 'Вы получите',
  'home.you_will_have_description':
    'Создавайте эффективные и надёжные процессы, контролируйте обслуживание, назначайте и отслеживайте задания, управляйте запасами и получайте автоматические отчёты для прозрачности и ответственности.',

  key_features: 'Ключевые возможности',
  key_features_description:
    'Некоторые функции, которые делают {{shortBrandName}} одной из лучших CMMS сегодня',
  contribute: 'Внести вклад',

  work_orders: 'Наряд-заказы',
  request_system: 'Система заявок',
  mobile_app: 'Мобильное приложение',
  asset_management: 'Управление активами',
  preventive_maintenance: 'Плановое обслуживание',
  parts_inventory: 'Склад запчастей',
  custom_dashboards: 'Пользовательские панели',

  'work-requests.title': 'Упрощённая система заявок',
  'work-requests.descriptions.0':
    'Устали от звонков и писем, которые теряются, создают хаос и дублируют работу?',
  'work-requests.descriptions.1':
    'Решение {{shortBrandName}} позволяет любому авторизованному пользователю отправить заявку в отдел обслуживания, просто отсканировав QR-код или перейдя по ссылке и заполнив форму на мобильном устройстве.',
  'work-requests.checks.0': 'Никогда больше не теряйте заявки.',
  'work-requests.checks.1': 'Сократите время обработки заявок до 34%.',
  'work-requests.checks.2':
    'Снизьте время общения с заявителями до 41% (звонки, письма, сообщения).',

  // --- Mobile App ---
  'mobile-app.title': 'Мобильное приложение CMMS для вашей команды',
  'mobile-app.descriptions.0':
    'С помощью Android-приложения наши клиенты повышают организацию, коммуникацию, ответственность и продуктивность до 30% во всей команде.',
  'mobile-app.descriptions.1': 'С мобильного устройства любой сотрудник может:',
  'mobile-app.checks.0': 'Просматривать назначенные наряды и ТО.',
  'mobile-app.checks.1':
    'Регистрировать выполнение наряда менее чем за минуту.',
  'mobile-app.checks.2': 'Получать мгновенные уведомления (push и email).',
  'mobile-app.checks.3': 'Создавать новые наряды прямо в поле.',
  'mobile-app.checks.4': 'Регистрировать проблемы во время работы над ними.',
  'mobile-app.checks.5':
    'Просматривать критическую информацию об активах при диагностике.',
  'eam.title': 'Управление активами предприятия',
  'eam.description.short': 'Знайте свои активы',
  'eam.descriptions.0':
    'Устали от хаоса в учёте оборудования, не знаете, обслуживалось ли оно должным образом, сколько стоит его содержание и другие головные боли?',
  'eam.descriptions.1':
    'Модуль управления активами {{brandName}} позволяет отслеживать от 10 до 1 000 000 активов, структурируя их в удобное дерево и делая поиск простым.',
  'eam.checks.0':
    'Знайте состояние активов и их стоимость в любой момент времени',
  'eam.checks.1':
    'Просматривайте полные и детализированные журналы обслуживания',
  'eam.checks.2':
    'Отслеживайте только то, что нужно, с неограниченными кастомными полями',
  'eam.checks.3': 'Организуйте активы в иерархию «родитель-дочерний»',
  'eam.checks.4': 'Быстро находите информацию с помощью QR-кодов',
  'eam.checks.5': 'Получайте данные в реальном времени через датчики',

  // --- Preventive Maintenance ---
  'pm.title': 'Эффективная программа планового обслуживания',
  'pm.descriptions.0':
    'Хватит тратить часы на ручное распределение чек-листов ТО и контроль выполнения.',
  'pm.descriptions.1':
    '{{shortBrandName}} позволяет автоматизировать планирование ТО, чтобы работа попадала к нужному технику в нужное время для нужного актива.',
  'pm.checks.0':
    'Автоматизируйте планирование ТО: ежедневно, еженедельно, ежемесячно, ежегодно или по событиям',
  'pm.checks.1':
    'Автоматические push- и email-уведомления при создании или наступлении ТО',
  'pm.checks.2':
    'Удобный календарь для просмотра всех открытых работ и будущих ТО',
  'pm.checks.3': 'Перетаскивайте задачи для изменения даты выполнения',
  'pm.checks.4':
    'После завершения ТО запись автоматически добавляется в журнал актива',
  'pm.checks.5': 'Простота использования — почти не требует обучения',
  'part.title': 'Контроль склада запчастей',
  'part.description.short': 'Знайте, когда запчасти закончатся',
  'part.descriptions.0':
    'Не уверены, какие запчасти есть в наличии и где они используются? Не знаете, когда они закончатся или хватит ли их для работы техников?',
  'part.descriptions.1':
    'Мы разработали систему управления запчастями {{shortBrandName}}, чтобы решить эти проблемы и многое другое:',
  'part.checks.0':
    'Мгновенные push- и email-уведомления при низком уровне запасов. Настройте порог и получайте уведомления автоматически.',
  'part.checks.1':
    'Техники сразу видят наличие запчасти в наряде. Если её нет — легко проверить другие склады.',
  'part.checks.2':
    'Автоматический учёт использования запчастей. При выполнении нарядов склад обновляется автоматически.',
  'part.checks.3':
    'Просматривайте журнал использования запчастей: где применялись и кем.',
  'part.checks.4':
    'Устраняйте залежавшиеся запчасти. Знайте, когда деталь устарела.',
  'part.checks.5':
    'Отчёты в реальном времени: какие запчасти используются и сколько они стоят.',
  'part.checks.6':
    'Оптимизация запасов: прогнозируйте использование запчастей на год вперёд.',
  'part.checks.7':
    'Поиск по штрих-коду. Делайте склад удобным для учёта и доступа с QR-кодами.',

  // --- Custom Dashboards ---
  'dashboard.title': 'Ваши данные — ваши панели',
  'dashboard.descriptions.0':
    'Первый шаг к улучшению работы — видеть сильные и слабые стороны.',
  'dashboard.descriptions.1':
    'С пользовательскими панелями {{shortBrandName}} вы сможете понять «чёрную дыру обслуживания» и начать действовать на основе данных, снижая затраты и простои.',
  'dashboard.descriptions.2': 'С {{shortBrandName}} вы получите возможность:',
  'dashboard.checks.0': 'Знать, куда уходят деньги и почему',
  'dashboard.checks.1': 'Определять самые дорогие активы и причины',
  'dashboard.checks.2': 'Создавать собственные KPI',
  'dashboard.checks.3': 'Просматривать отчёты, обновляемые автоматически',
  'dashboard.checks.4':
    'Делиться отчётами через Excel, PDF или внутри {{shortBrandName}}',
  'dashboard.checks.5': 'И многое другое...',
  'home.smarter': 'Умнее',
  'home.work': 'Работа',
  'home.smarter_description':
    '{{shortBrandName}} делает работу техников максимально эффективной, предоставляя им доступ к инструментам и данным прямо с ладони.',
  leading_maintenance: 'Лидируем в будущем обслуживания и надёжности',
  premium_included: 'Премиум-функции включены',
  no_credit_card: 'Без необходимости вводить карту',
  perfect_tool: 'Идеальный инструмент для команд обслуживания',
  start_trial_today: 'Начните бесплатный пробный период сегодня',

  create_account: 'Создать аккаунт',
  signup_description: 'Заполните поля ниже, чтобы зарегистрировать аккаунт.',
  account_already: 'Уже есть аккаунт?',
  signin_here: 'Войти здесь',

  invalid_email: 'Введите корректный адрес электронной почты',
  required_email: 'Поле Email обязательно',
  required_firstName: 'Поле Имя обязательно',
  required_lastName: 'Поле Фамилия обязательно',
  required_company: 'Поле Название компании обязательно',
  required_employeesCount: 'Укажите количество сотрудников',
  invalid_phone: 'Некорректный номер телефона',
  required_password: 'Поле Пароль обязательно',
  required_terms: 'Вы должны согласиться с условиями',
  verify_email: 'Проверьте почту для активации аккаунта',
  registration_error: 'Регистрация не удалась',

  first_name: 'Имя',
  last_name: 'Фамилия',
  email: 'Электронная почта',
  phone: 'Телефон',
  password: 'Пароль',
  companyName: 'Название компании',
  employeesCount: 'Количество сотрудников',
  i_accept: 'Я принимаю',
  terms_conditions: 'условия и положения',
  create_your_account: 'Создать аккаунт',
  register: 'Регистрация',

  login_description: 'Заполните поля ниже, чтобы войти в аккаунт.',
  no_account_yet: 'Ещё нет аккаунта?',
  signup_here: 'Зарегистрироваться здесь',
  wrong_credentials: 'Неверные данные для входа',
  lost_password: 'Забыли пароль?',
  link_wo: 'Связать наряды',
  link_wo_description: 'Создавайте связи между нарядами',
  required_relationType: 'Выберите тип связи',
  required_wo: 'Поле наряда обязательно',
  this_wo: 'Этот наряд',
  the_wo: 'Наряд',
  link: 'Связать',

  cost_description: 'Описание затрат',
  assigned_to: 'Назначено',
  category: 'Категория',
  date: 'Дата',
  cost: 'Стоимость',
  include_cost: 'Включить эту стоимость в общую',
  include_cost_description:
    'Эта сумма будет добавлена в общие затраты по наряду',
  required_cost_description: 'Описание затрат обязательно',
  required_cost: 'Стоимость обязательна',
  add_cost: 'Добавить дополнительные затраты',
  add_cost_description: 'Заполните поля ниже, чтобы добавить затраты',
  add: 'Добавить',

  hourly_rate: 'Почасовая ставка',
  include_time: 'Включить это время в общее',
  include_time_description:
    'Эта длительность будет добавлена в общее время по наряду',
  work_started_at: 'Работа начата',
  duration: 'Длительность',
  hours: 'Часы',
  minutes: 'Минуты',
  required_hours: 'Поле Часы обязательно',
  required_minutes: 'Поле Минуты обязательно',
  add_time: 'Добавить время',
  add_time_description: 'Заполните поля ниже, чтобы добавить время',

  feedback: 'Отзыв',
  feedback_description: 'Оставьте отзыв',
  required_feedback: 'Отзыв обязателен',
  signature: 'Подпись',
  required_signature: 'Изображение обязательно',

  close_wo: 'Закрыть наряд',
  close: 'Закрыть',
  task_update_success: 'Задача успешно обновлена',
  task_update_failure: 'Не удалось обновить задачу',
  notes_save_success: 'Заметки сохранены',
  images_add_task_success: 'Изображения добавлены к задаче',
  images_add_task_failure: 'Что-то пошло не так',
  images: 'Изображения',
  required_images: 'Загрузите хотя бы одно изображение',
  add_images: 'Добавить изображения',

  tasks: 'Задачи',
  wo_archive_success: 'Наряд успешно архивирован',
  wo_archive_failure: 'Не удалось архивировать наряд',
  wo_archive_confirm: 'Вы уверены, что хотите архивировать этот наряд?',
  quantity_change_success: 'Количество успешно изменено',
  quantity_change_failure: 'Не удалось изменить количество',

  details: 'Детали',
  updates: 'Обновления',
  id: 'ID',
  due_date: 'Срок выполнения',
  location: 'Локация',
  asset: 'Актив',
  team: 'Команда',
  created_at: 'Дата создания',
  list_view: 'Список',
  calendar_view: 'Календарь',
  column_view: 'Колонки',

  wo_create_success: 'Наряд успешно создан',
  wo_create_failure: 'Не удалось создать наряд',
  changes_saved_success: 'Изменения сохранены',
  wo_update_failure: 'Не удалось отредактировать наряд',
  wo_delete_success: 'Наряд успешно удалён',
  wo_delete_failure: 'Не удалось удалить наряд',

  status: 'Статус',
  title: 'Название',
  priority: 'Приоритет',
  description: 'Описание',
  worker: 'Исполнитель',
  location_name: 'Название локации',
  location_address: 'Адрес локации',
  asset_name: 'Название актива',
  days_since_creation: 'Дней с момента создания',
  files: 'Файлы',
  requested_by: 'Запрошено',
  completed_on: 'Завершено',
  updated_at: 'Обновлено',
  work_order: 'Наряд',
  timer_running: 'Таймер запущен',
  run_timer: 'Запустить таймер',
  approved_by: 'Утверждено',
  created_by: 'Создано',
  completed_by: 'Завершено',
  time: 'Время',
  save: 'Сохранить',
  customers: 'Подрядчики',
  no_labor:
    'Затраты на труд ещё не добавлены. Они появятся здесь, когда пользователь зарегистрирует время и у него будет сохранена почасовая ставка в {{shortBrandName}}.',
  not_assigned: 'Не назначено',
  no_additional_cost: 'Дополнительные затраты ещё не добавлены',
  parts: 'Запчасти',
  links: 'Связи',

  confirm_delete_file_wo: 'Вы уверены, что хотите удалить этот файл из наряда?',
  archive: 'Архив',
  labors: 'Трудозатраты',
  add_additional_cost: 'Добавить дополнительные затраты',
  additional_costs: 'Дополнительные затраты',
  add_parts: 'Добавить запчасти',

  'wo.title_description': 'Введите название наряда',
  image: 'Изображение',
  estimated_duration: 'Оценочная длительность (часы)',
  primary_worker: 'Основной исполнитель',
  additional_workers: 'Дополнительные исполнители',
  select_team: 'Выберите команду',
  select_location: 'Выберите локацию',
  select_asset: 'Выберите актив',
  select_tasks: 'Выберите задачи',
  select_pm: 'Select Preventive Maintenance routine',
  requires_signature: 'Требуется подпись',
  required_wo_title: 'Название наряда обязательно',
  add_wo: 'Добавить наряд',
  add_wo_description: 'Заполните поля ниже, чтобы создать новый наряд',
  edit_wo: 'Редактировать наряд',
  edit_wo_description: 'Заполните поля ниже, чтобы обновить наряд',

  'noRows.wo.message':
    'Наряды — это задачи или работы, которые можно планировать или назначать',
  'noRows.wo.action': "Нажмите '+' чтобы создать наряд",
  to_delete: 'Удалить',
  confirm_delete_wo: 'Вы уверены, что хотите удалить этот наряд?',
  no_access_wo:
    'У вас нет доступа к нарядам. Обратитесь к администратору, если доступ нужен',
  cancel: 'Отмена',
  select_parts: 'Выберите запчасти',
  sets_of_parts: 'Наборы запчастей',
  paused: 'Приостановлен',
  trigger_details: 'Детали триггера',
  starts_on: 'Начало',
  ends_on: 'Окончание',
  frequency: 'Частота',
  every_frequency_days: 'Каждые {{frequency}} дней',
  wo_details: 'Детали наряда',
  confirm_delete_file: 'Вы уверены, что хотите удалить этот файл?',

  wo_schedule_success: 'Наряд успешно запланирован',
  wo_schedule_failure: 'Не удалось запланировать наряд',
  wo_trigger_edit_failure: 'Не удалось отредактировать триггер наряда',
  wo_trigger_delete_success: 'Триггер наряда успешно удалён',
  wo_trigger_delete_failure: 'Не удалось удалить триггер наряда',

  name: 'Имя',
  wo_title: 'Название наряда',
  next_wo: 'Следующий наряд',
  trigger_name: 'Название триггера',
  enter_trigger_name: 'Введите название триггера',
  frequency_description: 'Частота в днях',
  wo_configuration: 'Конфигурация наряда',
  required_trigger_name: 'Название триггера обязательно',
  required_frequency: 'Частота обязательна',
  invalid_frequency: 'Частота должна быть больше 0',

  schedule_wo: 'Запланировать наряд',
  schedule_wo_description: 'Заполните поля ниже, чтобы запланировать наряд',
  edit_wo_trigger: 'Редактировать триггер наряда',
  edit_wo_trigger_description:
    'Заполните поля ниже, чтобы обновить триггер наряда',
  create_trigger: 'Создать триггер',

  'noRows.pm.message': 'Планируйте наряды с кастомными триггерами',
  'noRows.pm.action': "Нажмите '+' чтобы создать триггер",
  confirm_delete_pm: 'Вы уверены, что хотите удалить триггер наряда?',
  no_access_pm:
    'У вас нет доступа к разделу планового обслуживания. Обратитесь к администратору, если доступ нужен',
  enter_wo_title: 'Введите название наряда',

  status_report: 'Отчёт по статусу',
  wo_analysis: 'Анализ нарядов',
  wo_aging: 'Старение нарядов',
  time_and_cost: 'Время и затраты',
  assets: 'Активы',
  reliability_dashboard: 'Панель надёжности',
  total_maintenance_cost: 'Общие затраты на обслуживание',
  useful_life: 'Срок службы',
  requests: 'Заявки',
  locations: 'Локации',
  parts_and_inventory: 'Запчасти/Склад',
  purchase_orders: 'Заказы на закупку',
  meters: 'Счётчики',
  people_teams: 'Люди и команды',
  people: 'Люди',
  teams: 'Команды',
  vendors_customers: 'Поставщики и подрядчики',
  vendors: 'Поставщики',
  categories: 'Категории',
  settings: 'Настройки',

  cancelled: 'Отменено',
  reject: 'Отклонить',
  approve: 'Одобрить',

  request_create_success: 'Заявка успешно создана',
  request_create_failure: 'Не удалось создать заявку',
  request_edit_failure: 'Не удалось отредактировать заявку',
  request_delete_success: 'Заявка успешно удалена',
  request_delete_failure: 'Не удалось удалить заявку',

  rejected: 'Отклонено',
  approved: 'Одобрено',
  pending: 'В ожидании',

  required_request_name: 'Название заявки обязательно',
  required_field: 'Это поле обязательно',
  add_request: 'Добавить заявку',
  add_request_description: 'Заполните поля ниже, чтобы создать новую заявку',
  edit_request: 'Редактировать заявку',
  edit_request_description: 'Заполните поля ниже, чтобы обновить заявку',

  'noRows.request.message': 'Управляйте своими заявками',
  'noRows.request.action': "Нажмите '+' чтобы создать заявку",
  confirm_delete_request: 'Вы уверены, что хотите удалить эту заявку?',
  request: 'Заявка',
  request_details: 'Детали заявки',

  none_priority: 'Нет',
  low_priority: 'Низкий',
  medium_priority: 'Средний',
  high_priority: 'Высокий',

  downtimes: 'Простои',
  confirm_delete_file_asset:
    'Вы уверены, что хотите удалить этот файл из актива?',
  actions: 'Действия',
  show: 'Показать',
  model: 'Модель',
  serial_number: 'Серийный номер',
  operational: 'Работает',
  down: 'Не работает',
  area: 'Зона',
  barcode: 'Штрих-код',
  placed_in_service: 'Введён в эксплуатацию',
  warranty_expiration: 'Окончание гарантии',
  asset_information: 'Информация об активе',
  more_informations: 'Дополнительная информация',

  confirm_delete_asset_downtime: 'Вы уверены, что хотите удалить этот простой?',
  create_downtime_success: 'Простой успешно добавлен',
  create_downtime_failure: 'Не удалось добавить простой',
  edit_downtime_success: 'Простой успешно отредактирован',
  started_on: 'Начало',
  required_startsOn: 'Дата начала обязательна',

  reading_create_success: 'Показание успешно добавлено',
  reading_create_failure: 'Не удалось добавить показание',
  reading: 'Показание',
  added_by: 'Добавлено',
  enter_meter_value: 'Введите значение счётчика',
  add_reading: 'Добавить показание',
  select_meter: 'Выберите счётчик',

  confirm_delete_part_asset:
    'Вы уверены, что хотите удалить эту запчасть из актива?',
  no_due_date: 'Без срока',
  due_at_date: 'Срок {{date}}',
  no_primary_worker: 'Нет основного исполнителя',
  no_wo_linked_asset: 'Нет наряда, связанного с этим активом',

  asset_remove_success: 'Актив успешно удалён',
  asset_remove_failure: 'Не удалось удалить актив',
  asset_name_description: 'Введите название актива',
  select_asset_location: 'Выберите локацию актива',
  primary_user_description: 'Выберите основного пользователя',
  teams_description: 'Выберите команды',
  customers_description: 'Выберите подрядчиков',
  vendors_description: 'Выберите поставщиков',
  inServiceDate_description: 'Дата ввода в эксплуатацию',
  warranty_expiration_date: 'Дата окончания гарантии',
  additional_information: 'Дополнительная информация',
  structure: 'Структура',
  parent_asset: 'Родительский актив',

  asset_create_success: 'Актив успешно создан',
  asset_create_failure: 'Не удалось создать актив',
  additional_workers_description: 'Выберите дополнительных исполнителей',
  required_asset_name: 'Название актива обязательно',
  add_asset: 'Добавить актив',
  add_asset_description: 'Заполните поля ниже, чтобы создать новый актив',
  create_asset: 'Создать актив',
  hierarchy: 'Иерархия',
  add_downtime: 'Добавить простой',
  edit_downtime: 'Редактировать простой',
  remove_downtime: 'Удалить простой',
  edit: 'Редактировать',
  edit_asset: 'Редактировать актив',
  edit_asset_description: 'Заполните поля ниже, чтобы обновить актив',
  confirm_delete_asset: 'Вы уверены, что хотите удалить этот актив?',
  loading_assets: 'Загрузка активов в {{name}} #{{id}}',
  no_content: 'Нет данных',
  no_result_criteria: 'Нет результатов по заданным критериям',
  map_view: 'Карта',
  location_create_success: 'Локация успешно создана',
  location_create_failure: 'Не удалось создать локацию',
  location_edit_failure: 'Не удалось отредактировать локацию',
  location_delete_success: 'Локация успешно удалена',
  location_delete_failure: 'Не удалось удалить локацию',
  enter_location_name: 'Введите название локации',
  address: 'Адрес',
  parent_location: 'Родительская локация',
  select_workers: 'Выберите сотрудников',
  map_coordinates: 'Координаты на карте',
  required_location_name: 'Название локации обязательно',
  required_location_address: 'Адрес локации обязателен',
  add_location: 'Добавить локацию',
  add_location_description: 'Заполните поля ниже, чтобы создать новую локацию',
  edit_location: 'Редактировать локацию',
  edit_location_description: 'Заполните поля ниже, чтобы обновить локацию',
  confirm_delete_location: 'Вы уверены, что хотите удалить эту локацию?',

  // --- Floor Plans ---
  floor_plans: 'Планы этажей',
  floor_plan: 'План этажа',
  floor_plan_name_description: 'Название плана этажа',
  'Floor plan area in m²': 'Площадь плана этажа в м²',
  upload_image: 'Загрузить изображение',
  required_floor_plan_name: 'Название плана этажа обязательно',
  add_floor_plan: 'Добавить новый план этажа',
  add_floor_plan_description:
    'Заполните поля ниже, чтобы создать новый план этажа',
  no_asset_in_location: 'Нет активов в этой локации',
  no_wo_in_location: 'Нет нарядов в этой локации',
  no_file_in_location: 'Нет файлов, прикреплённых к этой локации',
  no_floor_plan_in_location: 'Нет плана этажа в этой локации',

  // --- Assignments ---
  assigned_teams: 'Назначенные команды',
  assigned_customers: 'Назначенные подрядчики',
  assigned_vendors: 'Назначенные поставщики',

  // --- Access Restrictions ---
  no_access_location:
    'У вас нет доступа к локациям. Обратитесь к администратору, если доступ нужен',
  no_access_vendors_customers:
    'У вас нет доступа к разделу Поставщики и Подрядчики. Обратитесь к администратору',
  no_access_people_team:
    'У вас нет доступа к разделу Люди и Команды. Обратитесь к администратору',
  no_access_analytics:
    'У вас нет доступа к аналитике. Обратитесь к администратору',
  no_access_assets: 'У вас нет доступа к активам. Обратитесь к администратору',
  no_access_categories:
    'У вас нет доступа к категориям. Обратитесь к администратору',
  no_access_files: 'У вас нет доступа к файлам. Обратитесь к администратору',
  no_access_inventory:
    'У вас нет доступа к складу. Обратитесь к администратору',
  no_access_meters:
    'У вас нет доступа к счётчикам. Обратитесь к администратору',
  no_access_purchase_orders:
    'Вы не можете создавать заказы на закупку. Обратитесь к администратору',
  no_access_requests:
    'У вас нет доступа к заявкам. Обратитесь к администратору',
  no_access_settings:
    'У вас нет доступа к настройкам. Обратитесь к администратору',
  no_access_page: 'У вас нет доступа к этой странице',
  set_create_success: 'Набор успешно создан',
  set_create_failure: 'Не удалось создать набор',
  set_edit_failure: 'Не удалось отредактировать набор',
  set_delete_success: 'Набор успешно удалён',
  set_delete_failure: 'Не удалось удалить набор',
  total_cost: 'Общая стоимость',
  part: 'Запчасть',
  enter_part_name: 'Введите название запчасти',
  required_set_name: 'Название набора обязательно',
  add_set: 'Добавить набор',
  add_set_description: 'Заполните поля ниже, чтобы создать новый набор',
  create_set: 'Создать набор',
  edit_set: 'Редактировать набор',
  edit_set_description: 'Заполните поля ниже, чтобы обновить набор',
  confirm_delete_set: 'Вы уверены, что хотите удалить этот набор?',

  // --- Parts ---
  part_create_success: 'Запчасть успешно создана',
  part_create_failure: 'Не удалось создать запчасть',
  part_edit_failure: 'Не удалось отредактировать запчасть',
  part_delete_success: 'Запчасть успешно удалена',
  part_delete_failure: 'Не удалось удалить запчасть',
  quantity: 'Количество',
  open_wo: 'Открытые наряды',
  enter_part_category: 'Введите категорию запчасти',
  enter_part_cost: 'Введите стоимость запчасти',
  enter_part_quantity: 'Введите количество запчасти',
  minimum_quantity: 'Минимальное количество',
  enter_part_minimum_quantity: 'Введите минимальное количество',
  non_stock: 'Не складская',
  enter_part_barcode: 'Введите штрих-код запчасти',
  enter_part_area: 'Введите зону хранения',
  additional_part_details: 'Дополнительные детали запчасти',
  add_part: 'Добавить запчасть',
  add_part_description: 'Заполните поля ниже, чтобы создать новую запчасть',
  create_part: 'Создать запчасть',
  update_part: 'Обновить запчасть',
  update_part_description: 'Заполните поля ниже, чтобы обновить запчасть',
  'noRows.part.message':
    'Запчасти можно объединять в активы или использовать отдельно',
  'noRows.part.action': "Нажмите '+' чтобы создать запчасть",
  confirm_delete_part: 'Вы уверены, что хотите удалить эту запчасть?',
  part_details: 'Детали запчасти',
  area_details: 'Детали зоны',
  assigned_people: 'Назначенные сотрудники',
  no_asset_related_part: 'Нет актива, связанного с этой запчастью',
  no_file_found: 'Файл не найден',
  no_wo_found: 'Наряд не найден',
  workers: 'Сотрудники',
  Parts_and_Inventory: 'Запчасти и склад',

  // --- Purchase Orders ---
  po_edit_failure: 'Не удалось отредактировать заказ',
  po_delete_success: 'Заказ успешно удалён',
  po_delete_failure: 'Не удалось удалить заказ',
  number_of_items: 'Количество позиций',
  total_quantity: 'Общее количество',
  shipping_to: 'Доставка в',
  shipping_address: 'Адрес доставки',
  po_details: 'Детали заказа',
  enter_po_name: 'Введите название заказа',
  additional_details: 'Дополнительные детали',
  vendor: 'Поставщик',
  shipping_information: 'Информация о доставке',
  company_name: 'Название компании',
  ship_to: 'Доставить',
  city: 'Город',
  state: 'Область',
  zip_code: 'Почтовый индекс',
  fax_number: 'Факс',
  po_date: 'Дата заказа',
  notes: 'Заметки',
  add_notes: 'Добавить заметки',
  requisitioner: 'Заявитель',
  terms: 'Условия',
  shipping_method: 'Способ доставки',
  required_name: 'Название обязательно',
  edit_po: 'Редактировать заказ',
  edit_po_description: 'Заполните поля ниже, чтобы обновить заказ',
  purchase_order: 'Заказ на закупку',
  'noRows.po.message': 'Управляйте заказами в одном месте',
  'noRows.po.action': "Нажмите '+' чтобы создать заказ",
  confirm_delete_po: 'Вы уверены, что хотите удалить этот заказ на закупку?',
  upgrade_po: 'Обновите тариф, чтобы создавать заказы на закупку',
  new_po: 'Новый заказ на закупку',
  po_create_success: 'Заказ на закупку успешно создан',
  select_one_part: 'Выберите хотя бы одну запчасть',
  po_create_failure: 'Не удалось создать заказ на закупку',
  approve_while_submitting: 'Одобрить при отправке',
  invalid_fax: 'Некорректный номер факса',
  submit: 'Отправить',
  each_item_superior_zero: 'Количество каждой позиции должно быть больше 0',
  quantity_edit_success: 'Количество успешно изменено',
  quantity_edit_failure: 'Не удалось изменить количество',

  APPROVED: 'Одобрено',
  PENDING: 'В ожидании',
  REJECTED: 'Отклонено',

  when_reading_is: 'Когда показание счётчика',
  greater_than: 'Больше чем',
  lower_than: 'Меньше чем',
  value: 'Значение',
  required_value: 'Значение обязательно',
  required_trigger_condition: 'Условие обязательно',

  wo_trigger_create_success: 'Триггер наряда успешно создан',
  wo_trigger_create_failure: 'Не удалось создать триггер наряда',
  add_wo_trigger: 'Добавить триггер наряда',
  add_wo_trigger_description:
    'Заполните поля ниже, чтобы создать триггер наряда',
  wo_trigger_edit_success: 'Триггер наряда успешно обновлён',

  meter_create_success: 'Счётчик успешно создан',
  meter_create_failure: 'Не удалось создать счётчик',
  meter_edit_failure: 'Не удалось отредактировать счётчик',
  meter_delete_success: 'Счётчик успешно удалён',
  meter_delete_failure: 'Не удалось удалить счётчик',

  next_reading_due: 'Следующее показание',
  unit_of_measurement: 'Единица измерения',
  last_reading: 'Последнее показание',
  enter_meter_name: 'Введите название счётчика',
  unit: 'Единица',
  update_frequency: 'Частота обновления',
  update_frequency_in_days: 'Частота обновления в днях',
  required_meter_name: 'Название счётчика обязательно',
  required_meter_unit: 'Единица счётчика обязательна',
  required_meter_update_frequency: 'Частота обновления счётчика обязательна',
  required_asset: 'Актив обязателен',
  add_meter: 'Добавить счётчик',
  add_meter_description: 'Заполните поля ниже, чтобы создать новый счётчик',
  edit_meter: 'Редактировать счётчик',
  edit_meter_description: 'Заполните поля ниже, чтобы отредактировать счётчик',
  confirm_delete_meter: 'Вы уверены, что хотите удалить этот счётчик?',
  upgrade_create_meter: 'Обновите тариф, чтобы создавать счётчики',
  history: 'История',
  reading_frequency: 'Частота показаний',
  required_reading_value: 'Значение показания обязательно',
  wo_triggers: 'Триггеры нарядов',
  add_trigger: 'Добавить триггер',
  meter_details: 'Детали счётчика',
  'noRows.meter.message':
    'Показания счётчиков позволяют отслеживать активы и запускать новые наряды по заданным условиям',
  'noRows.meter.action': "Нажмите '+' чтобы создать счётчик",
  meter: 'Счётчик',

  drag_one_file: 'Перетащите один файл сюда',
  drag_many_files: 'Перетащите файлы сюда',
  drop_to_start: 'Отпустите файлы, чтобы начать загрузку',
  invalid_files_type: 'Вы не можете загружать файлы этого типа',
  you_have_uploaded: 'Вы загрузили',
  upload: 'Загрузить',

  // --- Vendors & Customers ---
  Vendors_Customers: 'Поставщики и подрядчики',
  customer_create_success: 'Подрядчик успешно создан',
  customer_create_failure: 'Не удалось создать подрядчика',
  customer_edit_failure: 'Не удалось отредактировать подрядчика',
  customer_delete_success: 'Подрядчик успешно удалён',
  customer_delete_failure: 'Не удалось удалить подрядчика',
  customer_name: 'Имя подрядчика',
  website: 'Веб-сайт',
  customer_type: 'Тип подрядчика',
  customer_type_description: 'например: сантехника, электрика',
  customer_description_description:
    'Опишите назначение этого подрядчика в нескольких строках...',
  billing_information: 'Платёжная информация',
  address_line_2: 'Адрес (строка 2)',
  billing_name: 'Имя для выставления счёта',
  currency: 'Валюта',
  select_currency: 'Выберите валюту',
  required_customer_name: 'Имя подрядчика обязательно',
  required_phone: 'Номер телефона обязателен',
  invalid_website: 'Некорректный веб-сайт',
  billing_address: 'Адрес для выставления счёта',
  add_customer: 'Добавить подрядчика',
  add_customer_description:
    'Заполните поля ниже, чтобы создать нового подрядчика',
  'noRows.customer.message': 'Подрядчики — это внешние работники',
  'noRows.customer.action': "Нажмите '+' чтобы создать подрядчика",
  type: 'Тип',
  billing_currency: 'Валюта выставления счёта',
  go_back: 'Назад',
  confirm_delete_customer: 'Вы уверены, что хотите удалить этого подрядчика?',
  vendor_create_success: 'Поставщик успешно создан',
  vendor_create_failure: 'Не удалось создать поставщика',
  vendor_edit_failure: 'Не удалось отредактировать поставщика',
  vendor_delete_success: 'Поставщик успешно удалён',
  vendor_delete_failure: 'Не удалось удалить поставщика',
  required_company_name: 'Название компании обязательно',
  vendor_type: 'Тип поставщика',
  contact_name: 'Имя контакта',
  add_vendor: 'Добавить поставщика',
  add_vendor_description:
    'Заполните поля ниже, чтобы создать нового поставщика',
  confirm_delete_vendor: 'Вы уверены, что хотите удалить этого поставщика?',
  'noRows.vendor.message':
    'Поставщики — это организации, которые предоставляют активы или запчасти',
  'noRows.vendor.action': "Нажмите '+' чтобы создать поставщика",
  vendor_type_description: 'например: сантехника, электрика',

  // --- Users ---
  role: 'Роль',
  edit_user: 'Редактировать пользователя',
  edit_user_description:
    'Заполните поля ниже, чтобы отредактировать пользователя',
  job_title: 'Должность',
  invite_users: 'Пригласить пользователей',
  bring_people_team: 'Добавьте новых людей в команду',
  add_20_users:
    "Вы можете добавить до 20 пользователей за раз, нажимая 'Tab' или 'Enter' после каждого email. Дубликаты и уже зарегистрированные адреса будут удалены при регистрации.",
  enter_email: 'Введите адрес электронной почты',
  users_invite_success: 'Пользователи приглашены',
  users_invite_failure:
    'Не удалось пригласить пользователей. Проверьте количество доступных мест в подписке',
  please_type_emails: 'Введите email-адреса для приглашения',
  please_select_role: 'Выберите роль',
  invite: 'Пригласить',

  // --- Teams ---
  team_create_success: 'Команда успешно создана',
  team_create_failure: 'Не удалось создать команду',
  team_edit_failure: 'Не удалось отредактировать команду',
  team_delete_success: 'Команда успешно удалена',
  team_delete_failure: 'Не удалось удалить команду',
  team_name: 'Название команды',
  people_in_team: 'Люди в команде',
  required_team_name: 'Название команды обязательно',
  create_team: 'Создать команду',
  create_team_description: 'Здесь вы можете добавить участников команды',
  confirm_delete_team: 'Вы уверены, что хотите удалить эту команду?',
  overview: 'Обзор',
  activity: 'Активность',
  // --- Work Orders Summary ---
  wo_complete_last_14_days: 'Наряды, завершённые за последние 14 дней',
  no_wo_complete_last_14_days:
    'За последние две недели вы не завершили ни одного наряда',

  // --- Roles ---
  ADMIN_name: 'Администратор',
  ADMIN_description:
    'Администратор имеет полный доступ: редактирование, добавление, удаление нарядов и заявок',
  LIMITED_ADMIN_name: 'Ограниченный администратор',
  LIMITED_ADMIN_description:
    'Ограниченный администратор имеет те же права, что и администратор, кроме доступа к настройкам и управлению людьми/командами. Он не может удалять наряды, активы, локации, счётчики и заказы на закупку, если не создал подрядчиков, категории и триггеры ТО.',
  TECHNICIAN_name: 'Техник',
  TECHNICIAN_description:
    'Техники могут создавать и закрывать наряды, активы и локации. Могут редактировать и удалять только то, что создали сами',
  LIMITED_TECHNICIAN_name: 'Ограниченный техник',
  LIMITED_TECHNICIAN_description:
    'Ограниченные техники видят только наряды, назначенные им',
  VIEW_ONLY_name: 'Только просмотр',
  VIEW_ONLY_description:
    'Пользователи с правами только просмотра имеют полный доступ к просмотру, но не могут редактировать',
  REQUESTER_name: 'Заявитель',
  REQUESTER_description:
    'Заявители могут только отправлять заявки и просматривать их статус',
  select_user_role: 'Выберите роль пользователя',

  // --- Teams ---
  'noRows.team.message': 'Команды помогают управлять группами людей',
  'noRows.team.action': "Нажмите '+' чтобы создать команду",
  user_details: 'Детали пользователя',

  // --- Files ---
  file_delete_success: 'Файл успешно удалён',
  file_delete_failure: 'Не удалось удалить файл',
  uploaded_by: 'Загружено',
  uploaded_on: 'Дата загрузки',
  rename: 'Переименовать',
  required_files: 'Загрузите хотя бы один файл',
  required_file_name: 'Введите имя файла',
  add_files: 'Добавить файлы',
  edit_file: 'Редактировать файл',
  'noRows.file.message': 'Все файлы в одном месте',
  'noRows.file.action': "Нажмите '+' чтобы загрузить файл",
  upgrade_files:
    'Обновите тариф, чтобы использовать файлы в активах, нарядах, локациях и т.д.',

  // --- Analytics ---
  parts_consumption: 'Потребление запчастей',
  requests_analysis: 'Анализ заявок',

  // --- Categories ---
  category_create_success: 'Категория успешно создана',
  category_create_failure: 'Не удалось создать категорию',
  category_edit_failure: 'Не удалось отредактировать категорию',
  category_delete_success: 'Категория успешно удалена',
  category_delete_failure: 'Не удалось удалить категорию',
  timers: 'Таймеры',
  costs: 'Затраты',
  add_category: 'Добавить новую категорию',
  add_category_description: 'Введите название, чтобы создать категорию',
  edit_category: 'Редактировать категорию',
  edit_category_description:
    'Введите название, чтобы отредактировать категорию',
  no_category_action: "Нажмите '+' чтобы добавить первую категорию",
  confirm_delete_category: 'Вы уверены, что хотите удалить эту категорию?',
  no_category_message: 'Похоже, у вас ещё нет категорий {{categoryName}}',

  acquisition_cost: 'Стоимость приобретения',

  // --- Settings ---
  general_settings: 'Общие настройки',
  request_form_configuration: 'Конфигурация формы заявки',
  roles: 'Роли',
  checklists: 'Чек-листы',
  field_configuration_description:
    'Вы можете отметить поля как необязательные, скрытые или обязательные',
  optional: 'Необязательное',
  required: 'Обязательное',
  hidden: 'Скрытое',
  creating_wo: 'Создание наряда',
  completing_wo: 'Завершение наряда',

  // --- Roles ---
  role_edit_failure: 'Не удалось отредактировать роль',
  edit_role: 'Редактировать роль',
  edit_role_description: 'Заполните поля ниже, чтобы отредактировать роль',
  external_id: 'Внешний ID',
  permissions: 'Разрешения',
  create_role_description:
    'Эта роль может делать всё, что и Администратор в {{brandName}}, но вы можете настроить некоторые важные разрешения ниже.',
  create_and_edit: 'Создание/Редактирование',
  to_access: 'Доступ',
  role_delete_success: 'Роль успешно удалена',
  role_delete_failure: 'Не удалось удалить роль',
  confirm_delete_role: 'Вы уверены, что хотите навсегда удалить эту роль?',
  users: 'Пользователи',
  paid: 'Платная',
  free: 'Бесплатная',
  role_create_success: 'Роль успешно создана',
  role_create_failure: 'Не удалось создать роль',
  roles_management: 'Управление ролями',
  roles_number: '{{count}} ролей',
  create_role: 'Создать роль',
  upgrade_role: 'Обновите тариф, чтобы создавать роли',
  add_role: 'Добавить новую роль',
  add_role_description: 'Заполните поля ниже, чтобы создать новую роль',
  parts_and_sets: 'Запчасти и наборы запчастей',
  upgrade_role_edit: 'Обновите тариф, чтобы редактировать роли',
  delete_role: 'Удалить роль',
  upgrade_role_delete: 'Обновите тариф, чтобы удалять роли',
  create: 'Создать',

  // --- Preventive Maintenance Trigger ---
  pm_trigger: 'Триггер планового обслуживания',
  auto_assign_wo: 'Автоматическое назначение нарядов',
  auto_assign_wo_description:
    'Автоматически назначать новые наряды пользователю, который их создал',
  auto_assign_requests: 'Автоматическое назначение заявок',
  auto_assign_requests_description:
    'Автоматически назначать новые наряды пользователю, который одобрил заявку',
  disable_closed_wo_notification: 'Отключить уведомления о закрытых нарядах',
  disable_closed_wo_notification_description:
    'Отключить уведомления при обновлении закрытых нарядов',
  ask_feedback_wo_closed: 'Запрашивать отзыв при закрытии наряда',
  ask_feedback_wo_closed_description:
    'Пользователям предлагается оставить отзыв о выполненной работе',
  include_labor_in_total_cost: 'Включить трудозатраты в общую стоимость',
  include_labor_in_total_cost_description:
    'Добавлять трудозатраты в общую сумму, когда пользователь регистрирует время и имеет сохранённую ставку',
  enable_wo_updates_requesters: 'Включить обновления нарядов для заявителей',
  enable_wo_updates_requesters_description:
    'Пользователи получают обновления по нарядам, которые они запросили',

  // --- General Settings ---
  language: 'Язык',
  date_format: 'Формат даты',
  time_zone: 'Часовой пояс',
  business_type: 'Тип бизнеса',
  general_asset_management: 'Общее управление активами',
  physical_asset_management: 'Управление физическими активами',

  // --- Checklists ---
  checklist_delete_success: 'Чек-лист успешно удалён',
  checklist_delete_failure: 'Не удалось удалить чек-лист',
  create_checklist: 'Создать чек-лист',
  confirm_delete_checklist: 'Вы уверены, что хотите удалить этот чек-лист?',
  upgrade_checklist: 'Обновите тариф, чтобы использовать чек-листы',
  upgrade_now: 'Обновить сейчас',
  total: 'Итого',
  sub_task_status: 'Статус подзадачи',
  text_field: 'Текстовое поле',
  number_field: 'Числовое поле',
  inspection_check: 'Проверка',
  multiple_choices: 'Множественный выбор',
  meter_reading: 'Показание счётчика',
  select_user: 'Выберите пользователя',
  PASS: 'Пройдено',
  FLAG: 'Флаг',
  FAIL: 'Не пройдено',
  enter_task_name: 'Введите название задачи',
  see_details: 'Посмотреть детали',
  concerned_asset: 'Связанный актив',
  me: 'Я',
  remove_blank_tasks: 'Удалить пустые задачи',
  remove_blank_options: 'Удалить пустые варианты',
  preview: 'Предпросмотр',
  edit_checklist: 'Редактировать чек-лист',
  add_tasks: 'Добавить задачи',
  use_a_checklist: 'Использовать чек-лист',
  select_checklist: 'Выберите чек-лист',
  save_checklist: 'Сохранить чек-лист',
  assign_tasks_description:
    'Назначайте кастомные задачи для заполнения техниками',
  select_date: 'Выберите дату',
  task: 'Задача',
  checklist: 'Чек-лист',

  // --- Analytics ---
  upgrade_analytics: 'Обновите тариф, чтобы видеть аналитику',
  grouped_by_category: 'Сгруппировано по категориям',
  downtime_by_asset: 'Простой по активам',
  downtime_and_costs: 'Простой и затраты',
  downtime_and_costs_trends: 'Тренды простоев и затрат',
  downtimes_trends: 'Тренды простоев',
  repair_time_by_asset: 'Время ремонта по активам',
  consumed_parts_costs: 'Затраты на использованные запчасти',
  requests_by_priority: 'Заявки по приоритету',
  requests_trends: 'Тренды заявок',
  time_spent: 'Затраченное время',
  grouped_by_completed_by: 'Сгруппировано по исполнителю',
  grouped_by_assigned_to: 'Сгруппировано по назначенному',
  grouped_by_priority: 'Сгруппировано по приоритету',
  completion_comparison: 'Сравнение выполнения',
  hours_worked: 'Отработанные часы',
  work_remaining: 'Оставшаяся работа',
  wo_status: 'Статус наряда',
  cost_trends: 'Тренды затрат',
  cost_center: 'Анализ жизненного цикла актива',
  downtime_and_availability: 'Простои и доступность',
  incomplete_wo: 'Незавершённые наряды',
  the_numbers: 'Цифры',
  hours_and_cost_by_asset: 'Часы и затраты по активам',

  completion_comparison_description:
    'Сравнение различных типов завершённых нарядов.',
  wo_age_description:
    'Возраст наряда определяется как количество дней между созданием наряда (или заявки) и его завершением.',
  rav_description:
    'Общая стоимость как % от RAV = (стоимость нарядов по активу / цена покупки)*100. Стандарт отрасли — целевое значение 3%.',
  downtime_and_availability_description:
    'Доступность — это процент времени, когда активы находились в рабочем состоянии с момента ввода в эксплуатацию. Общие простои — количество событий простоев за указанный период.',
  total_cost_description:
    'Общая стоимость включает трудозатраты, дополнительные расходы и стоимость запчастей в наряде.',
  compliant_wo_description:
    'Соответствующие наряды — это наряды, завершённые до срока. Время цикла — количество дней до завершения наряда.',
  hours_worked_description:
    'Эти часы соответствуют нарядам, срок выполнения которых попадает в диапазон, указанный в фильтрах.',
  work_remaining_description:
    'Этот график показывает количество незавершённых нарядов, срок которых попадает в диапазон фильтров. Оценочные часы соответствуют этим нарядам.',

  total_downtime_in_hours: 'Общий простой (часы)',
  downtime_events: 'События простоев',
  percent_downtime: '% простоя',
  meantime_between_failures_in_hours: 'Среднее время между отказами (часы)',
  availability_percent: 'Процент доступности',
  mean_time_to_repair_in_hours: 'Среднее время ремонта (часы)',
  average_age: 'Средний возраст',
  count: 'Количество',
  average_cost: 'Средняя стоимость',
  compliant: 'Соответствующий',
  average_cycle_time_in_days: 'Среднее время цикла (дни)',
  total_consumption_cost: 'Общая стоимость потребления',
  parts_consumed: 'Использованные запчасти',
  total_cost_as_pct_rav: 'Общая стоимость как % от RAV',
  approved_requests: 'Одобренные заявки',
  pending_requests: 'Заявки в ожидании',
  cancelled_requests: 'Отменённые заявки',
  average_cycle_time: 'Среднее время цикла',
  compliance_rate: 'Уровень соответствия',
  complete: 'Завершено',
  reactive: 'Реактивное',
  recurring: 'Повторяющееся',
  part_costs: 'Затраты на запчасти',
  labor_costs: 'Затраты на труд',
  total_time_spent_in_hours: 'Общее затраченное время (часы)',
  estimated_hours: 'Оценочные часы',
  total_purchase_price: 'Общая цена покупки',

  // --- Company & Account ---
  you_have: 'У вас',
  new_messages: 'новых сообщений',
  company: 'Компания',
  change_cover: 'Изменить обложку',
  required_address: 'Поле адреса обязательно',
  company_details: 'Детали компании',
  company_details_description:
    'Управляйте информацией, связанной с вашей компанией',
  learn_more: 'Подробнее',
  profile: 'Профиль',

  // --- Notifications & Emails ---
  email_notifications: 'Email-уведомления',
  email_updates_wo: 'Email-обновления по нарядам и сообщениям',
  email_updates_requests: 'Email-обновления по заявкам на наряды',
  po_emails: 'Email по заказам на закупку',

  // --- Password & Security ---
  required_job_title: 'Поле должности обязательно',
  required_old_password: 'Введите текущий пароль',
  invalid_password: 'Пароль слишком короткий — минимум 8 символов',
  required_new_password: 'Пароль не указан',
  passwords_must_match: 'Пароли должны совпадать',
  password_change_success: 'Пароль успешно изменён',
  wrong_password: 'Неверный пароль',
  current_password: 'Текущий пароль',
  new_password: 'Новый пароль',
  confirm_password: 'Подтвердите пароль',

  // --- Personal Details ---
  personal_details: 'Личные данные',
  personal_details_description:
    'Управляйте информацией, связанной с вашими личными данными',
  change_password: 'Изменить пароль',
  notification_settings: 'Настройки уведомлений',
  notification_settings_description: 'Управляйте параметрами уведомлений',
  recent_activity: 'Последняя активность',
  created: 'Создано',
  completed: 'Завершено',
  my_account: 'Мой аккаунт',
  my_company: 'Моя компания',
  you_are_using_plan:
    'Вы используете тариф {{planName}}. Он истекает {{expiration}}. Обновите тариф, чтобы получить больше возможностей.',
  upgrade_plan: 'Обновить тариф',
  plans: 'Тарифы',
  monthly: 'Ежемесячно',
  annually: 'Ежегодно',
  subscription_change_success: 'Подписка успешно изменена',
  invalid_credit_card: 'Некорректный номер карты',
  required_credit_card: 'Поле карты обязательно',
  invalid_expiration_month: 'Некорректный месяц окончания',
  required_expiration_month: 'Месяц окончания обязателен',
  invalid_expiration_year: 'Некорректный год окончания',
  required_expiration_year: 'Год окончания обязателен',
  invalid_cvv: 'Некорректный CVV',
  required_cvv: 'CVV обязателен',
  required_cardholder_name: 'Имя держателя карты обязательно',
  card: 'Карта',
  expiration_month: 'Месяц окончания',
  expiration_year: 'Год окончания',
  cardholder_name: 'Имя держателя карты',
  seats: 'Места',
  cost_per_seat: 'Стоимость за место',
  your_payment_secure: 'Ваши платёжные данные зашифрованы и защищены.',
  plan: 'Тариф',
  current_plan: 'Текущий тариф',
  number_users_who_will_use_grash:
    'Количество пользователей, которые будут использовать {{shortBrandName}}',
  admin_role: 'Администратор',
  technical_role: 'Техник',
  limited_technical_role: 'Ограниченный техник',
  requester_role: 'Заявитель',
  view_only_role: 'Только просмотр',
  how_will_you_be_billed: 'Как вы хотите оплачивать?',
  which_plan_fits_you: 'Какой тариф вам подходит?',
  per_user_month: 'за пользователя/месяц',
  per_user_year: 'за пользователя/год',
  you_will_be_charged: 'С вас будет списано',
  proceed_to_payment: 'Перейти к оплате',
  pay_only_for_roles:
    'Оплачивайте только <strong>Администраторов</strong>, <strong>Техников</strong> и <strong>Ограниченных техников</strong>, а <strong>Заявители</strong> и <strong>Только просмотр</strong> — бесплатно',
  checkout_our: 'Посмотрите нашу',
  pricing_page: 'Страницу тарифов',
  for_more_details: 'для подробностей',
  users_count_display: '{{count}} пользователей',
  monthly_adverb: 'ежемесячно',
  yearly_adverb: 'ежегодно',
  features: 'Функции',
  checkout: 'Оформление',
  checkout_description: 'Заполните поля ниже',
  per_month: 'в месяц',
  per_year: 'в год',

  // --- Password Recovery ---
  recover_password_description:
    'Введите email, использованный при регистрации, чтобы сбросить пароль.',
  send_me_new_password: 'Отправить новый пароль',
  want_to_sign_in_again: 'Хотите попробовать войти снова?',
  check_mails_for_instructions: 'Проверьте почту для дальнейших инструкций',

  // --- Reports ---
  pdf_report: 'PDF-отчёт',

  // --- Priorities ---
  HIGH: 'Высокий',
  MEDIUM: 'Средний',
  LOW: 'Низкий',
  NONE: 'Нет',

  // --- Import ---
  import: 'Импорт',
  start_import_process: 'Начать процесс импорта',
  import_data: 'Импорт данных',
  set_header: 'Установить заголовок',
  match_columns: 'Сопоставить столбцы',
  review: 'Проверка',
  done: 'Готово',
  no_match_yet: 'Совпадений пока нет',
  select: 'Выберите...',
  matched_to_field: 'Сопоставлено с {{field}}',
  next: 'Далее',
  not_enough_rows: 'Недостаточно строк в файле',
  there_are_duplicates: 'Есть дубликаты: {{duplicates}}',
  assigned_by: 'Назначено',
  percent_rows_have_value: '{{percent}}% строк имеют значение',
  match_at_least_column: 'Сопоставьте хотя бы один столбец',
  to_import: 'Импорт',
  required_match: 'Сопоставление {{field}} обязательно',
  archived: 'Архивировано',
  // --- Import Success ---
  import_wo_success: '{{created}} нарядов создано и {{updated}} обновлено',
  import_location_success:
    '{{created}} локаций создано и {{updated}} обновлено',
  import_part_success: '{{created}} запчастей создано и {{updated}} обновлено',
  import_meter_success: '{{created}} счётчиков создано и {{updated}} обновлено',
  import_asset_success: '{{created}} активов создано и {{updated}} обновлено',

  // --- Export & Filters ---
  to_export: 'Экспорт',
  filters: 'Фильтры',
  more_filters: 'Дополнительные фильтры',
  customer: 'Подрядчик',
  to: 'до',
  dates: 'Даты',
  start: 'Начало',
  end: 'Окончание',
  longitude: 'Долгота',
  latitude: 'Широта',
  ALL: 'Все',
  REACTIVE: 'Реактивное',
  REPEATING: 'Плановое',

  // --- Calendar ---
  wo_calendar: 'Календарь нарядов',
  month: 'Месяц',
  week: 'Неделя',
  day: 'День',
  agenda: 'Повестка',
  previous: 'Предыдущий',
  today: 'Сегодня',

  // --- Filters & Search ---
  to_filter: 'Фильтр',
  reset_filters: 'Сбросить фильтры',
  toggle_menu: 'Переключить меню',
  no_results: 'Результатов не найдено',
  an_error_occured: 'Произошла ошибка',
  density: 'Плотность',
  compact: 'Компактный',
  standard: 'Стандартный',
  comfortable: 'Удобный',
  columns: 'Столбцы',
  select_columns: 'Выберите столбцы',
  show_filters: 'Показать фильтры',
  hide_filters: 'Скрыть фильтры',
  search_placeholder: 'Поиск…',
  search: 'Поиск',
  clear: 'Очистить',

  // --- Export Options ---
  download_as_csv: 'Скачать как CSV',
  print: 'Печать',
  download_as_excel: 'Скачать как Excel',

  // --- Table & Columns ---
  find_column: 'Найти столбец',
  column_title: 'Название столбца',
  reorder_column: 'Изменить порядок столбцов',
  show_all: 'Показать все',
  hide_all: 'Скрыть все',
  add_filter: 'Добавить фильтр',
  logic_operator: 'Логический оператор',
  operator: 'Оператор',
  and: 'И',
  or: 'Или',
  filter_value: 'Значение фильтра',
  contains: 'содержит',
  equals: 'равно',
  starts_with: 'начинается с',
  ends_with: 'заканчивается на',
  is: 'является',
  is_not: 'не является',
  is_after: 'после',
  is_on_or_after: 'в или после',
  is_before: 'до',
  is_on_or_before: 'в или до',
  is_empty: 'пусто',
  is_not_empty: 'не пусто',
  is_any_of: 'является одним из',
  any: 'любой',
  true_text: 'истина',
  false_text: 'ложь',
  menu: 'Меню',
  show_columns: 'Показать столбцы',
  hide: 'Скрыть',
  unsort: 'Сбросить сортировку',
  sort_by_ASC: 'Сортировать по возрастанию',
  sort_by_DESC: 'Сортировать по убыванию',
  sort: 'Сортировка',
  total_rows: 'Всего строк:',
  yes: 'Да',
  no: 'Нет',
  more: 'Ещё',
  to_group: 'Группировать',
  see_children: 'показать дочерние',
  hide_children: 'скрыть дочерние',
  expand: 'Развернуть',
  collapse: 'Свернуть',
  detail_panel_toggle: 'Переключить панель деталей',

  // --- Subscription ---
  cancel_subscription: 'Отменить подписку',
  resume_subscription: 'Возобновить подписку',
  confirm_cancel_subscription: 'Вы уверены, что хотите отменить подписку?',
  // --- Workflows ---
  workflows: 'Рабочие процессы',
  create_workflow: 'Создать рабочий процесс',
  if: 'Если',
  and_optional: 'И (необязательно)',
  then: 'То',
  workflow_description:
    'Создавайте кастомные рабочие процессы так же просто, как «Если, И, То». Экономьте время и автоматически назначайте наряды через рабочие процессы, адаптируя {{shortBrandName}} под работу вашей команды.\nВсе тарифы позволяют создать до 1 кастомного процесса. Чтобы добавить больше, обновите тариф до Business.',
  CREATE_PURCHASE_ORDER: 'Создать заказ на закупку',
  PART_IS: 'Запчасть',
  QUANTITY_INFERIOR: 'Количество меньше чем',
  ASSIGN_VENDOR: 'Назначить поставщика',
  ASSIGN_CATEGORY: 'Назначить категорию',
  APPROVE: 'Одобрить',
  REJECT: 'Отклонить',
  SEND_REMINDER_EMAIL: 'Отправить напоминание по email',
  VENDOR_IS: 'Поставщик',
  CATEGORY_IS: 'Категория',
  STATUS_IS: 'Статус',
  DUE_DATE_BETWEEN: 'Срок между',
  DUE_DATE_AFTER: 'Срок после',
  ASSIGN_PRIORITY: 'Назначить приоритет',
  ASSIGN_ASSET: 'Назначить актив',
  ASSIGN_LOCATION: 'Назначить локацию',
  ASSIGN_USER: 'Назначить пользователя',
  ASSIGN_TEAM: 'Назначить команду',
  ADD_CHECKLIST: 'Добавить чек-лист',
  PRIORITY_IS: 'Приоритет',
  ASSET_IS: 'Актив',
  LOCATION_IS: 'Локация',
  USER_IS: 'Пользователь',
  TEAM_IS: 'Команда',
  CREATED_AT_BETWEEN: 'Создан между',
  TITLE_CONTAINS: 'Название содержит',
  CREATE_REQUEST: 'Создать заявку',
  CREATE_WORK_ORDER: 'Создать наряд',
  SET_ASSET_STATUS: 'Установить статус актива',
  NAME_IS: 'Имя',
  NAME_CONTAINS: 'Имя содержит',
  VALUE_IS: 'Значение',
  VALUE_CONTAINS: 'Значение содержит',
  NUMBER_VALUE_SUPERIOR: 'Значение больше чем',
  NUMBER_VALUE_INFERIOR: 'Значение меньше чем',
  WORK_ORDER_CREATED: 'Наряд создан',
  WORK_ORDER_CLOSED: 'Наряд закрыт',
  WORK_ORDER_ARCHIVED: 'Наряд архивирован',
  REQUEST_CREATED: 'Заявка создана',
  REQUEST_APPROVED: 'Заявка одобрена',
  REQUEST_REJECTED: 'Заявка отклонена',
  PURCHASE_ORDER_CREATED: 'Заказ на закупку создан',
  PURCHASE_ORDER_UPDATED: 'Заказ на закупку обновлён',
  TASK_UPDATED: 'Задача обновлена',
  PART_UPDATED: 'Запчасть обновлена',
  add_condition: 'Добавить условие',
  workflow_creation_success: 'Рабочий процесс успешно создан',
  workflow_creation_failure: 'Не удалось создать рабочий процесс',
  action_value_missing: 'Значение действия отсутствует',
  condition_value_missing: 'Значение условия отсутствует',
  workflow_edit_success: 'Рабочий процесс успешно обновлён',
  workflow_edit_failure: 'Не удалось отредактировать рабочий процесс',
  workflow_delete_success: 'Рабочий процесс успешно удалён',
  workflow_delete_failure: 'Не удалось удалить рабочий процесс',
  confirm_delete_workflow:
    'Вы уверены, что хотите удалить этот рабочий процесс?',
  click_here: 'Нажмите здесь',

  // --- Verify Email ---
  verify_email_title: 'Подтверждение Email',
  verify_email_description:
    'Вам отправлено письмо для подтверждения. Проверьте папку «Спам», если не видите его во входящих.',

  // --- Upgrade/Downgrade ---
  upgrade: 'Обновить',
  downgrade: 'Понизить',
  upgrade_description:
    'Вы только что обновили тариф. Вам нужно включить отключённых пользователей, которые могут использовать {{shortBrandName}}. Это можно сделать только один раз для текущей подписки. Выбирайте внимательно.',
  enable_users: 'Включить пользователей',
  max_users_description: 'Вы можете включить до {{maxUsers}} пользователей',
  downgrade_description:
    'Вы только что понизили тариф. Вам нужно отключить некоторых пользователей, чтобы продолжить. Это можно сделать только один раз для текущей подписки. Выбирайте внимательно.',
  disable_users: 'Отключить пользователей',
  min_users_description:
    'Необходимо отключить минимум {{minUsers}} пользователей',
  downgrade_description_no_owner:
    'Ваша компания понизила тариф. Владельцу компании нужно отключить некоторых пользователей, прежде чем вы сможете продолжить',

  past_due: 'Просрочено',
  due_date_delay: 'Задержка срока',
  due_date_delay_description: 'Задержка срока в днях',
  days_count: '{{days}} дней',
  trigger_configuration: 'Конфигурация триггера',

  // --- Features ---
  WORK_ORDER_feature: 'Наряды',
  REQUEST_feature: 'Заявки',
  PART_feature: 'Управление запчастями',
  MOBILE_APP_feature: 'Мобильное приложение',
  WORK_ORDER_HISTORY_feature: 'История нарядов',
  PREVENTIVE_MAINTENANCE_feature: 'Плановое обслуживание',
  CHECKLIST_feature: 'Чек-листы',
  FILE_feature: 'Загрузка файлов',
  PURCHASE_ORDER_feature: 'Заказы на закупку',
  METER_feature: 'Показания счётчиков',
  REQUEST_CONFIGURATION_feature: 'Конфигурация формы заявки',
  ADDITIONAL_TIME_feature: 'Расширенный учёт времени',
  ADDITIONAL_COST_feature: 'Расширенный учёт затрат',
  ANALYTICS_feature: 'Аналитика и отчёты',
  REQUEST_PORTAL_feature: 'Портал заявок',
  SIGNATURE_feature: 'Подписи',
  ROLE_feature: 'Кастомные роли',
  WORKFLOW_feature: 'Автоматизация рабочих процессов',
  API_ACCESS_feature: 'Доступ к API',
  WEBHOOK_feature: 'Вебхуки',
  IMPORT_CSV_feature: 'Импорт CSV',
  no_import_access: 'Обновите тариф, чтобы импортировать из CSV и Excel',

  // --- Company & Members ---
  add_new_option: 'Добавить новый вариант',
  edit_company: 'Редактировать компанию',
  fill_fields_below: 'Заполните поля ниже',
  members: 'Участники',
  assign_user: 'Назначить пользователя',
  assign_asset: 'Назначить актив',

  // --- Work Order Completion Requirements ---
  required_files_on_completion: 'Файлы обязательны при завершении наряда',
  required_tasks_on_completion: 'Задачи должны быть выполнены',
  required_labor_on_completion: 'Необходимо зарегистрировать время',
  required_part_on_completion: 'В этом наряде не использована ни одна запчасть',
  required_cost_on_completion: 'В этом наряде не указаны затраты',
  estimated_hours_in_text: '{{hours}} оценочных часов',
  required_part_name: 'Название запчасти обязательно',
  asset_update_failure: 'Не удалось отредактировать актив',

  // --- Legal & Policies ---
  terms_of_service: 'Условия использования',
  privacy_policy: 'Политика конфиденциальности',

  // --- User & Account ---
  last_login: 'Последний вход',
  not_enough_part: 'Недостаточно этой запчасти',
  remove_blank_meter_tasks: 'Удалить задачи типа «счётчик» без счётчика',
  checklist_update_failure: 'Не удалось отредактировать чек-лист',
  contact_us: 'Свяжитесь с нами',
  simplify_wo: 'Упростить наряды в мобильном приложении',
  simplify_wo_description:
    'Скрыть контроль времени, затраты и запчасти в деталях наряда при использовании мобильного приложения',
  account_deletion: 'Удаление аккаунта {{brandName}}',
  switch_account: 'Сменить аккаунт',
  switch_to_super_user: 'Переключиться на супер-администратора',
  switch_account_description: 'Выберите аккаунт для продолжения',
  put_location_in_map: 'Указать локацию на карте',
  confirm_disable_user:
    'Вы уверены, что хотите отключить {{user}}? Включить его можно будет только через месяц',
  user_disabled_success: 'Пользователь успешно отключён',
  disable: 'Отключить',

  // --- Assets & Import ---
  manufacturer: 'Производитель',
  power: 'Мощность',
  import_error: 'Импорт не удался',
  request_upgrade: 'Запросить обновление тарифа',
  operation_success: 'Операция выполнена успешно',
  CANCELLED: 'Отклонено',

  // --- Analytics & Reports ---
  uptime_hours: 'Время работы (ч)',
  downtime_hours: 'Простои (ч)',
  mark_all_as_seen: 'Отметить всё как просмотренное',
  estimation_accuracy_ratio: 'Коэффициент точности оценки',
  download_template: 'Скачать шаблон',
  pareto_by_total_price: 'Парето по общей стоимости',
  cumulative_percent: 'Накопленный процент',
  part_consumption_by_asset: 'Потребление запчастей по активам',
  grouped_by_wo_category: 'Сгруппировано по категории наряда',
  resolution_rate: 'Коэффициент решения',
  resolved: 'Решено',
  average: 'Среднее',
  documentation: 'Документация',
  days_before_pm_notification: 'Уведомления до планового наряда',
  estimated_start_date: 'Ожидаемая дата начала',
  no_file_linked_to_wo: 'К этому наряду не прикреплён файл',
  add_file: 'Добавить файл',

  // --- Plans & Marketing ---
  try_for_free: 'Попробовать бесплатно',
  choose_your_plan: 'Выберите тариф',
  STARTER_description:
    'Команды, стремящиеся построить эффективное плановое обслуживание с учётом состояния оборудования и видимости ресурсов.',
  PROFESSIONAL_description:
    'Отделы, которым нужны аналитика и инсайты для повышения продуктивности и развития обслуживания.',
  BUSINESS_description:
    'Организации, готовые собирать данные обслуживания и операций для управления несколькими локациями и кастомизацией системы.',
  book_demo: 'Заказать демо',
  request_pricing: 'Запросить цены для получения информации',

  // --- Reports & UI ---
  Reports: 'Отчёты',
  'Custom dashboard built using the included components':
    'Кастомная панель, созданная с использованием встроенных компонентов',
  Export: 'Экспорт',
  'Last year': 'Прошлый год',
  Expenses: 'Расходы',
  Statistics: 'Статистика',
  General: 'Общее',
  Calendar: 'Календарь',
  Mailbox: 'Почта',
  Dashboards: 'Панели',
  Analytics: 'Аналитика',
  Monitoring: 'Мониторинг',
  Tasks: 'Задачи',
  Applications: 'Приложения',
  Users: 'Пользователи',
  'List All': 'Список всех',
  'User Profile': 'Профиль пользователя',
  Login: 'Вход',
  Register: 'Регистрация',
  'Recover Password': 'Восстановить пароль',
  Status: 'Статус',
  'Error 404': 'Ошибка 404',
  'Error 500': 'Ошибка 500',
  'Coming Soon': 'Скоро',
  Maintenance: 'Обслуживание',
  Overview: 'Обзор',
  Documentation: 'Документация',
  Welcome: 'Добро пожаловать',
  Help: 'Помощь',
  'Features tour': 'Обзор функций',
  'Getting started guide': 'Руководство по началу работы',
  'Contact support': 'Связаться с поддержкой',
  Version: 'Версия',
  Search: 'Поиск',
  Notifications: 'Уведомления',
  Settings: 'Настройки',
  'Language Switcher': 'Переключатель языка',
  'Sign out': 'Выйти',
  'Change Theme': 'Сменить тему',
  'View all notifications': 'Просмотреть все уведомления',
  rate: 'оценка',
  select_at_least_column: 'Выберите хотя бы один столбец',
  already_read: 'Уже прочитано',

  // --- Asset Status ---
  OPERATIONAL: 'Работает',
  DOWN: 'Не работает',
  MODERNIZATION: 'Модернизация',
  STANDBY: 'Режим ожидания',
  INSPECTION_SCHEDULED: 'Запланирована инспекция',
  COMMISSIONING: 'Ввод в эксплуатацию',
  EMERGENCY_SHUTDOWN: 'Аварийная остановка',
  select_asset_status: 'Выберите статус актива',
  asset_status: 'Статус актива',

  // --- UI Configuration ---
  ui_configuration: 'Конфигурация интерфейса',
  password_leave_empty_if_you_dont_want_to_change:
    'Пароль — оставьте пустым, если не хотите менять',

  // --- Upgrade & Demo ---
  upgrade_request_success:
    'Запрос на обновление получен! Мы скоро свяжемся с вами для оплаты',
  continue_with_sso: 'Продолжить через SSO',
  see_live_demo: 'Посмотреть демо',
  demo_warning:
    'Этот экземпляр работает в демо-режиме. Не используйте его для реальных данных! Всё будет удаляться регулярно!',
  days: 'Дни',
  weeks: 'Недели',
  months: 'Месяцы',
  years: 'Годы',
  based_on: 'На основе',
  scheduled_date: 'Запланированная дата',
  on: 'В',
  required_days_of_week: 'Обязательные дни недели',
  'schedule.daily_one': 'Каждый {{count}} день',
  'schedule.daily_other': 'Каждые {{count}} дней',
  'schedule.weekly_one': 'Каждую {{count}} неделю в {{days}}',
  'schedule.weekly_other': 'Каждые {{count}} недели в {{days}}',
  'schedule.monthly_one': 'Каждый {{count}} месяц',
  'schedule.monthly_other': 'Каждые {{count}} месяцев',
  'schedule.yearly_one': 'Каждый {{count}} год',
  'schedule.yearly_other': 'Каждые {{count}} лет',
  csv_separator: 'разделитель CSV',
  open_source_cmms: 'CMMS с открытым исходным кодом',
  'main.title':
    'Бесплатная CMMS с открытым исходным кодом (программное обеспечение для управления обслуживанием)',
  'home.h1':
    'Бесплатная CMMS с открытым исходным кодом, которую можно хостить самостоятельно или использовать в облаке',
  'home.h2': 'Мощное обслуживание по низкой цене',
  'home.h3':
    'Хватит полагаться на таблицы и доски. {{brandName}} помогает сервисным командам планировать работы, отслеживать оборудование и соблюдать стандарты. Хостите на своём сервере или начните мгновенно в облаке.',
  talk_to_sales: 'Связаться с отделом продаж',
  'pricing.choose_plan_and_get_started':
    'Выберите свой тарифный план и начните.',
  'pricing.slogan_effective_maintenance':
    'Наше программное обеспечение предоставляет командам по техническому обслуживанию и обеспечению надежности инструменты, необходимые для эффективного и результативного управления производственными процессами.',
  'pricing.compare_plans_and_pricing': 'Сравните тарифные планы и цены.',
  'pricing.see_which_plan_is_right_for_you':
    'Узнайте, какой план подходит именно вам.',
  'pricing.select_two_plans_to_compare':
    'Выберите 2 тарифных плана для сравнения.',
  'pricing.select_three_plans_to_compare':
    'Выберите 3 тарифных плана для сравнения.',
  'pricing.month_per_user': 'месяц на пользователя',
  'pricing.year_per_user': 'год на пользователя',
  'pricing.plan_basic_name': 'Базовый',
  'pricing.plan_basic_description':
    'Команды, стремящиеся отслеживать активы и создавать базовые графики профилактического обслуживания с соответствующими процедурами.',
  'pricing.feature_unlimited_work_orders':
    'Неограниченное количество заказов на работы',
  'pricing.feature_custom_tasks': 'Пользовательские задачи',
  'pricing.feature_unlimited_request_user_licenses':
    'Неограниченное количество запросов на пользовательские лицензии',
  'pricing.plan_starter_name': 'Стартер',
  'pricing.plan_starter_description':
    'Команды стремятся создать эффективную и надежную систему профилактического обслуживания, обеспечивая прозрачность состояния оборудования и численности персонала.',
  'pricing.feature_everything_in_basic_plus':
    'Всё, что входит в базовый пакет плюс:',
  'pricing.feature_preventive_maintenance_recurring_work_orders':
    'Плановое техническое обслуживание/Регулярные заявки на ремонт',
  'pricing.feature_custom_checklists': 'Пользовательские контрольные списки',
  'pricing.feature_inventory_management_costing':
    'Управление запасами/Расчет стоимости',
  'pricing.feature_time_and_manpower_tracking':
    'Учет рабочего времени и численности персонала',
  'pricing.feature_thirty_day_analytics_reporting':
    '30-дневная аналитика и отчетность',
  'pricing.plan_professional_name': 'Профессиональный',
  'pricing.plan_professional_description':
    'Подразделениям, которым необходимо использовать аналитические данные для дальнейшего роста и повышения производительности в сфере технического обслуживания.',
  'pricing.feature_everything_in_starter_plus':
    'Всё, что входит в пакет Starter plus:',
  'pricing.feature_multiple_inventory_lines': 'Несколько товарных позиций',
  'pricing.feature_customizable_request_portal':
    'Настраиваемый портал запросов',
  'pricing.feature_mobile_offline_mode': 'Мобильный офлайн-режим',
  'pricing.feature_advanced_analytics_reporting':
    'Расширенная аналитика и отчетность',
  'pricing.plan_business_name': 'Бизнес',
  'pricing.plan_business_description':
    'Организации, готовые собирать данные о техническом обслуживании и эксплуатации для управления несколькими объектами и настройки системы.',
  'pricing.feature_everything_in_professional_plus':
    'Все функции пакета Professional Plus:',
  'pricing.feature_purchase_order_management': 'Управление заказами на закупку',
  'pricing.feature_multi_site_module_support':
    'Поддержка многосайтовых модулей',
  'pricing.feature_custom_work_order_statuses':
    'Настраиваемые статусы заказов на выполнение работ',
  'pricing.feature_custom_integrations_support':
    'Поддержка пользовательских интеграций',
  'pricing.feature_work_order_management': 'Управление рабочими заданиями',
  'pricing.feature_recurring_work_orders': 'Повторяющиеся заказы на работы',
  'pricing.feature_custom_categories': 'Пользовательские категории',
  'pricing.feature_data_importing': 'Импорт данных',
  'pricing.feature_time_and_cost_tracking': 'Отслеживание времени и затрат',
  'pricing.feature_work_order_configuration': 'Конфигурация рабочего задания',
  'pricing.feature_internal_requests': 'Внутренние запросы',
  'pricing.feature_external_request_portal': 'Портал внешних запросов',
  'pricing.category_locations_assets_parts':
    'Местоположения, активы и комплектующие',
  'pricing.feature_location_management': 'Управление местоположением',
  'pricing.feature_barcode_scanning': 'Сканирование штрихкодов',
  'pricing.feature_inventory_management': 'Управление запасами',
  'pricing.feature_custom_asset_statuses': 'Пользовательские статусы активов',
  'pricing.feature_asset_downtime_tracking':
    'Отслеживание простоев оборудования',
  'pricing.feature_asset_depreciation_tracking':
    'Отслеживание амортизации активов',
  'pricing.feature_asset_warranty_tracking': 'Отслеживание гарантий на активы',
  'pricing.feature_purchase_orders_management': 'Заказы на закупку',
  'pricing.feature_asset_check_in_out': 'Прием/выдача активов',
  'pricing.category_mobile_offline': 'Мобильная версия: офлайн',
  'pricing.feature_work_order_availability':
    'Наличие заявок на выполнение работ',
  'pricing.feature_updating_status': 'Обновление статуса',
  'pricing.feature_updating_tasks': 'Обновление задач',
  'pricing.feature_work_order_drafts': 'Проекты заявок на выполнение работ',
  'pricing.feature_full_drill_down_reporting_history':
    'Подробная отчетность и история событий.',
  'pricing.period_thirty_days': '30 дней',
  'pricing.period_full': 'Полный',
  'pricing.feature_pdf_csv_exporting': 'Экспорт в форматы PDF и CSV',
  'pricing.feature_itemized_time_reporting': 'Детальный учет рабочего времени',
  'pricing.feature_user_login_reports':
    'Отчеты о входе пользователей в систему',
  'pricing.feature_parts_consumption_reports':
    'Отчеты об использовании комплектующих',
  'pricing.feature_asset_downtime_reports': 'Отчеты о простоях оборудования',
  'pricing.feature_equipment_reliability_reports':
    'Отчеты о надежности оборудования',
  'pricing.feature_multi_site_modules': 'Многосайтовые модули',
  'pricing.category_integrations': 'Интеграции',
  'pricing.feature_business_integrations':
    'Интеграция бизнес-процессов (SAP/Oracle/Causal AI...)',
  'pricing.feature_custom_integrations': 'Пользовательские интеграции',
  'pricing.feature_unlimited_view_only_users':
    'Неограниченное количество пользователей только для просмотра',
  'pricing.feature_unlimited_requesters': 'Неограниченное количество запросов',
  'pricing.feature_unlimited_vendors': 'Неограниченное количество продавцов',
  'pricing.feature_unlimited_customers': 'Неограниченное количество клиентов',
  'pricing.category_support': 'Поддерживать',
  'pricing.feature_daily_email_digest': 'Ежедневная сводка электронных писем',
  'pricing.feature_articles': 'Статьи',
  'pricing.feature_training_webinars': 'Обучающие вебинары',
  'pricing.feature_community_support_discord': 'Поддержка сообщества (Discord)',
  'pricing.feature_email_support': 'Поддержка по электронной почте',
  'pricing.feature_chat_phone_support': 'Поддержка в чате/по телефону',
  'pricing.feature_priority_support': 'Приоритетная поддержка',
  'pricing.feature_implementation_training': 'Внедрение и обучение',
  'pricing.feature_dedicated_account_manager':
    'Персональный менеджер по работе с клиентами',
  'pricing.category_customization': 'Настройка',
  'pricing.feature_custom_development': 'Разработка на заказ',
  'pricing.sh_plan_basic_name': 'Базовый',
  'pricing.sh_plan_basic_description':
    'Для небольших команд, которым необходима полная независимость данных и базовое отслеживание технического обслуживания собственной инфраструктуры.',
  'pricing.sh_feature_core_work_order_management':
    'Управление основными рабочими заданиями',
  'pricing.sh_feature_asset_inventory_tracking':
    'Отслеживание активов и запасов',
  'pricing.sh_feature_local_data_storage': 'Локальное хранилище данных',
  'pricing.sh_plan_professional_name': 'Профессиональный',
  'pricing.sh_plan_professional_description':
    'Идеально подходит для выращивания растений, требующих сложных контрольных списков, рабочих процессов и более глубокой системной интеграции.',
  'pricing.sh_feature_everything_in_basic_plus':
    'Всё, что входит в базовый пакет плюс:',
  'pricing.sh_feature_unlimited_assets_checklists':
    'Неограниченное количество ресурсов/контрольных списков',
  'pricing.sh_feature_nfc_barcode_scanning': 'NFC и сканирование штрих-кодов',
  'pricing.sh_feature_email_support': 'Поддержка по электронной почте',
  'pricing.sh_plan_business_name': 'Бизнес',
  'pricing.sh_plan_business_description':
    'Полномасштабные операции, требующие управления несколькими экземплярами, индивидуального брендинга и первоклассной безопасности.',
  'pricing.sh_feature_everything_in_professional_plus':
    'Все функции пакета Professional Plus:',
  'pricing.sh_feature_multi_instance_management':
    'Управление несколькими экземплярами',
  'pricing.sh_feature_custom_user_roles': 'Пользовательские роли',
  'pricing.sh_feature_priority_implementation_support':
    'Приоритетная поддержка внедрения',
  'pricing.faq_free_users_q': 'Какие типы пользователей считаются бесплатными?',
  'pricing.faq_free_users_a1':
    'Существует три типа пользователей, для которых платная лицензия не требуется:',
  'pricing.faq_view_only_users_title': 'Только для просмотра Пользователи',
  'pricing.faq_view_only_users_description':
    'Как правило, это руководители, которые нечасто заходят в систему, чтобы просмотреть общую картину технического обслуживания. Они также могут отправлять заявки на выполнение работ и формировать отчеты.',
  'pricing.faq_requester_users_title': 'Пользователи-заявители',
  'pricing.faq_requester_users_description':
    'Эти пользователи могут только отправлять заявки на выполнение работ и просматривать их статус. Они не могут видеть заказы на работы, активы, запчасти или любые другие данные, хранящиеся в системе CMMS.',
  'pricing.faq_third_party_users_title': 'Сторонние пользователи',
  'pricing.faq_third_party_users_description':
    'Как правило, это поставщики и подрядчики. Они не могут войти в систему напрямую. Они могут только отправлять обновления по конкретному рабочему заказу, к которому привязаны, через общедоступную ссылку.',
  'pricing.faq_paid_users_q': 'Какие типы пользователей считаются платными?',
  'pricing.faq_paid_users_a1':
    'Для трех типов пользователей требуется платная лицензия:',
  'pricing.faq_admin_users_title': 'Администраторы',
  'pricing.faq_admin_users_description':
    'Эти пользователи могут добавлять других пользователей в учетную запись, принимать или отклонять запросы на выполнение работ, а также редактировать детали заказов. Именно они управляют учетной записью. В одной учетной записи может быть несколько администраторов.',
  'pricing.faq_technical_users_title': 'Технические пользователи',
  'pricing.faq_technical_users_description':
    'Как правило, это технические специалисты, которые закрывают заказы на выполнение работ на объекте. Они могут редактировать созданные ими заказы, но не другие заказы. Они могут добавлять фотографии и обновления статуса к заказам, а также создавать новые заказы.',
  'pricing.faq_limited_technical_users_title':
    'Пользователи с ограниченными техническими навыками',
  'pricing.faq_limited_technical_users_description':
    'Эти пользователи обладают теми же привилегиями, что и технический пользователь. Единственное исключение заключается в том, что они могут видеть только назначенные им рабочие задания, а не других технических пользователей в учетной записи.',
  'pricing.faq_change_plans_q': 'Могу ли я изменить планы позже?',
  'pricing.faq_change_plans_a':
    'Да, вы можете в любое время изменить свой тарифный план на более высокий или более низкий. Изменения вступят в силу с началом следующего расчетного периода.',
  'pricing.faq_free_trial_q': 'Есть ли бесплатная пробная версия?',
  'pricing.faq_free_trial_a':
    'Да, мы предлагаем 15-дневную бесплатную пробную версию бизнес-плана, чтобы вы могли оценить все функции, прежде чем принимать решение.',
  'pricing.faq_non_profit_discounts_q':
    'Предоставляете ли вы скидки для некоммерческих организаций?',
  'pricing.faq_non_profit_discounts_a':
    'Да, мы предлагаем специальные цены для некоммерческих организаций. Для получения более подробной информации, пожалуйста, свяжитесь с нашим отделом продаж.',
  'pricing.faq_payment_methods_q': 'Какие способы оплаты вы принимаете?',
  'pricing.faq_payment_methods_a':
    'Мы принимаем все основные кредитные карты, банковские переводы и PayPal. Для корпоративных тарифных планов мы также можем организовать выставление счетов.',
  'pricing.faq_cancel_subscription_q': 'Могу ли я отменить подписку?',
  'pricing.faq_cancel_subscription_a':
    'Да, вы можете отменить подписку в любое время. Доступ к сервису сохранится до конца текущего расчетного периода.',
  'pricing.faq_data_secure_q': 'Мои данные в безопасности?',
  'pricing.faq_data_secure_a':
    'Да, мы очень серьезно относимся к безопасности данных. Все данные шифруются как при передаче, так и в состоянии покоя, и мы регулярно проводим проверки безопасности.',
  'pricing.faq_title': 'Часто задаваемые вопросы',
  'pricing.annually_save_two_months': 'Ежегодно (экономия 2 месяцев)',
  'pricing.most_popular': 'Самые популярные',
  'pricing.get_your_license': 'Получите водительские права',
  get_started: 'Начать',
  workflow_automation: 'Автоматизация рабочих процессов',
  push_notifications: 'Push-уведомления',
  cloud: 'Облако',
  self_hosted: 'Самостоятельное размещение',
  full: 'Полный',
  pricing: 'Цены',
  industries: 'Отрасли',
  work_order_management: 'Управление заказ-нарядами',
  inventory_management: 'Управление запасами',
  analytics_and_reporting: 'Аналитика и отчетность',
  manufacturing: 'Производство',
  facility_management: 'Управление инфраструктурой',
  food_and_beverage: 'Продукты питания и напитки',
  healthcare: 'Здравоохранение',
  energy_and_utilities: 'Энергетика и коммунальные услуги',
  education: 'Образование',
  hospitality: 'Гостиничный бизнес',
  construction: 'Строительство',
  upload_telemetry: 'Upload Telemetry',
  telemetry_dialog_title: 'Upload Telemetry File',
  telemetry_dialog_subtitle:
    'Select an Excel file with Placa, Kilometraje Final and Horómetro Final columns.',
  telemetry_uploading: 'Uploading…',
  telemetry_upload_success: 'Telemetry uploaded successfully',
  telemetry_upload_failure: 'Telemetry upload failed',
  telemetry_no_rows: 'No data rows found. Check that the sheet has a "Placa" header.',
  telemetry_result: 'Upload summary',
  telemetry_assets_updated: 'Assets updated',
  telemetry_readings_created: 'Readings created',
  telemetry_meters_created: 'Meters auto-created',
  telemetry_not_found: 'Unmatched plates',
  telemetry_ambiguous: 'Ambiguous plates (skipped)'
};

export default ruJSON;
